import React, { useState, useEffect } from "react";
import CustomFields from "../../customfields/CustomFields";
import {
  DialogActions,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  Checkbox,
  FormControlLabel,
  MenuItem,
  Select,
  FormControl,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import InputLabel from "@material-ui/core/InputLabel";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  formControl: {
    marginBottom: 5,
    width: "100%",
  },
}));
function CustomFieldsDialog(props) {
  const classes = useStyles();
  const [customFields, setCustomFields] = useState([]);
  const [addType, setAddType] = useState(null);
  const { t } = useTranslation();

  return (
    <Dialog
      fullWidth
      fullScreen
      open={props.open}
      onClose={props.onClose}
      PaperProps={{ style: { overflow: "inherit" } }}
    >
      <DialogContent>
        <CustomFields
          slate
          template
          customFieldsChange={(newCustomFields) =>
            setCustomFields(newCustomFields)
          }
        />
        {customFields.length > 0 && (
          <FormControl className={classes.formControl}>
            <InputLabel>Which data inserted</InputLabel>
            <Select
              aria-label="Which data inserted select"
              value={addType}
              onChange={(value) => setAddType(value.target.value)}
            >
              <MenuItem value={"Label"}>{"Label"}</MenuItem>
              <MenuItem value={"Value"}>{"Value"}</MenuItem>
              <MenuItem value={"Both"}>{"Both"}</MenuItem>
            </Select>
          </FormControl>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose} color="default" aria-label="Cancel">
          {t("global_cancel")}
        </Button>
        <Button
          aria-label="Insert button"
          disabled={customFields.length === 0 || addType === null}
          onClick={() => props.onSubmit(customFields, addType)}
          color="default"
        >
          {t("global_insert")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CustomFieldsDialog;
